import { render, staticRenderFns } from "./SelectDeliveryAreaForm.vue?vue&type=template&id=55f128a2&scoped=true&"
import script from "./SelectDeliveryAreaForm.vue?vue&type=script&lang=js&"
export * from "./SelectDeliveryAreaForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectDeliveryAreaForm.vue?vue&type=style&index=0&id=55f128a2&prod&lang=scss&scoped=true&"
import style1 from "./SelectDeliveryAreaForm.vue?vue&type=style&index=1&id=55f128a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f128a2",
  null
  
)

export default component.exports